module.exports = __webpack_public_path__ + "img/43.d4b913aa.jpg";